import './Affiliate.css'

import React from 'react'
import { useEffect, useState } from 'react'
import { Button, Spinner } from 'react-bootstrap'

import { createRef, getRef, getRefById } from '../../../services/affiliates'
import { getUser, updateUser } from '../../../services/users'

const MAX_REVENUE = 0.2
const MIN_REFNUM_LENGTH = 3

export default function AffiliateCreate({ onHide, onCreateNewRef }) {
  const [formState, setFormState] = useState({
    refUserId: '',
    refFullName: '',
    refNum: '',
    rev: 0,
    email: '',
    registeredUsers: 0,
    boughtPackages: 0,
    packagesShipmentIncome: 0,
    paymentCoupons: 0,
    paymentShipments: 0,
    paymentsHistory: [],
  })

  const [message, setMessage] = useState('')
  const [isUserIdOK, setIsUserIdOK] = useState(false)
  const [isCheckingUserId, setIsCheckingUserId] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [isDisableRev, setisDisableRev] = useState(false)

  const fillOldRefData = user => {
    if (user.Attributes.find(atr => atr.Name === 'custom:refRev')?.Value) setisDisableRev(true)
    setFormState({
      ...formState,
      rev: user.Attributes.find(atr => atr.Name === 'custom:refRev')?.Value ?? 0,
      refNum: user.Attributes.find(atr => atr.Name === 'custom:refNum')?.Value ?? '',
      email: user.Attributes.find(atr => atr.Name === 'email')?.Value ?? '',
      refFullName:
        `${user.Attributes.find(atr => atr.Name === 'name').Value} ${user.Attributes.find(atr => atr.Name === 'family_name').Value}` ?? '',
    })
  }

  const checkRefUserId = async ev => {
    ev.preventDefault()
    const cognitoRegexPattern = /^[a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12}$/gm
    if (!formState.refUserId.match(cognitoRegexPattern)) {
      setMessage('User ID not valid')
      return
    }

    setIsCheckingUserId(true)
    try {
      const cognitoUser = await getUser(formState.refUserId)
      if (!cognitoUser) {
        setMessage('User does not exist!')
        setIsCheckingUserId(false)
        return
      }
      fillOldRefData(cognitoUser)
      const refUser = await getRefById(formState.refUserId)
      // console.log("checkRefUserId - refUser", refUser)
      if (refUser.data.internalCode === 1) {
        setMessage('User already has ref code')
        setIsCheckingUserId(false)
        return
      } else {
        setIsUserIdOK(true)
        setMessage('')
        setIsCheckingUserId(false)
      }
    } catch (err) {
      console.log(err)
      setIsCheckingUserId(false)
    }
  }

  useEffect(() => {
    const handleKeyPress = e => {
      if (e.key === 'Escape') onHide()
    }
    document.addEventListener('keydown', handleKeyPress)
    return () => {
      document.removeEventListener('keydown', handleKeyPress)
    }
  }, [onHide])

  const validateForm = () => {
    if (!isUserIdOK) {
      setMessage('User ID is invalid')
      return false
    }
    if (formState.refNum?.length < MIN_REFNUM_LENGTH) {
      setMessage(`Ref Num must be at least ${MIN_REFNUM_LENGTH} characters`)
      return false
    }
    if (+formState.rev > MAX_REVENUE) {
      setMessage(`Ref revenue must be between 0-${MAX_REVENUE}`)
      return false // max revenue?
    }
    return true
  }

  const handleChange = ev => {
    setMessage('')
    setFormState({
      ...formState,
      [ev.target.name]: ev.target.value,
    })
    if (ev.target.name === 'refUserId') setIsUserIdOK(false)
  }

  const onSubmit = async () => {
    const isValid = validateForm()
    if (!isValid) return
    setIsSubmitting(true)
    try {
      const isRefNumTaken = await getRef(formState.refNum)

      if (isRefNumTaken?.data?.refNum) {
        setMessage(`refNum ${formState.refNum} is already in use!`)
      }
      if (!isRefNumTaken?.data?.refNum) {
        await createRef(formState)

        const attributes = {
          // 'custom:refRev': formState.rev,
          'custom:refNum': formState.refNum,
          email: formState.email,
        }
        await updateUser(attributes)
        onCreateNewRef(formState)
        onHide()
        return // avoid setIsSubmitting. unmounted
      }
    } catch (error) {
      console.log('onSubmit - err', error)
      setIsSubmitting(false)
      alert(`Failed! \n ${error.response.data?.msg}`)
    }
    setIsSubmitting(false)
  }

  return (
    <form className='ac-form'>
      <h3>Create New Ref User</h3>
      {message && <h6>{message}</h6>}
      <label>Ref User ID:</label>
      <div className='ac-form-refid'>
        <input name='refUserId' value={formState.refUserId} onChange={handleChange} type='text' placeholder='xxxx-xxxx-xxxx' />
        {!isCheckingUserId && (
          <button disabled={isUserIdOK || formState.refUserId.length < 1} onClick={checkRefUserId}>
            {isUserIdOK ? 'ID OK' : 'Check ID'}
          </button>
        )}
        {isCheckingUserId && (
          <button onClick={checkRefUserId}>
            <Spinner animation='border' variant='primary' />
          </button>
        )}
      </div>
      <label>Email:</label>
      <input name='email' value={formState.email} onChange={handleChange} type='text' placeholder='' />
      <label>Full Name:</label>
      <input name='refFullName' value={formState.refFullName} onChange={handleChange} type='text' placeholder='' />
      <label>Ref Num:</label>
      <input name='refNum' value={formState.refNum} onChange={handleChange} type='text' placeholder='' />
      <label>Revenue (refRev)</label>
      <input name='rev' value={formState.rev} onChange={handleChange} type='text' placeholder='0.05' disabled={isDisableRev} />
      <div className='ac-temp'>
        <span style={{ fontSize: '14px', textDecoration: 'underLine' }}>
          Temporary fields for old affiliate partners. For new one skip them.
        </span>
        <label>Bought Packages</label>
        <input name='boughtPackages' value={formState.boughtPackages} onChange={handleChange} type='number' />
        <label>Packages Shipment Income</label>
        <input name='packagesShipmentIncome' value={formState.packagesShipmentIncome} onChange={handleChange} type='number' />
        <label>Registered Users</label>
        <input name='registeredUsers' value={formState.registeredUsers} onChange={handleChange} type='number' />
        <label>Payment Coupons</label>
        <input name='paymentCoupons' value={formState.paymentCoupons} onChange={handleChange} type='number' />
        <label>Payment Shipments</label>
        <input name='paymentShipments' value={formState.paymentShipments} onChange={handleChange} type='number' />
      </div>
      <div className='ac-form-buttons'>
        {!isSubmitting && (
          <Button variant='primary' onClick={onSubmit}>
            Submit
          </Button>
        )}
        {isSubmitting && (
          <Button variant='primary' onClick={onSubmit}>
            <Spinner animation='border' variant='secondary' />
          </Button>
        )}
        <Button variant='secondary' onClick={onHide}>
          Cancel
        </Button>
      </div>
    </form>
  )
}
